import React, { useState, useEffect } from 'react';
import { Card } from 'antd';
import { Document, Page, pdfjs } from 'react-pdf';
import { PlusOutlined, MinusOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js'


//pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

// ✅ Configure worker for pdfjs-dist v4.x
//pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfViewer = React.memo(({ base64 }: { base64: string }) => {
    const [numPages, setNumPages] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [scale, setScale] = useState<number>(1.0);
    const [pdfUrl, setPdfUrl] = useState<string>("");

    useEffect(() => {
        if (base64) {
            const binary = atob(base64);
            const len = binary.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            const blob = new Blob([bytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            setPdfUrl(url);
        }
    }, [base64]);

    if (!base64) {
        return <Card>Loading document</Card>;
    }

    return (
        <Card title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold' }}>PDF Viewer</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button type="button" className="btn-submit" onClick={() => setPageNumber((prev) => Math.max(prev - 1, 1))}>
              <LeftOutlined />
            </button>
            <span>Page {pageNumber} of {numPages}</span>
            <button type="button" className="btn-submit" onClick={() => setPageNumber((prev) => Math.min(prev + 1, numPages))}>
              <RightOutlined />
            </button>
            <button type="button" className="btn-submit" onClick={() => setScale((s) => Math.max(0.5, s - 0.1))}>
              <MinusOutlined />
            </button>
            <span>{Math.round(scale * 100)}%</span>
            <button type="button" className="btn-submit" onClick={() => setScale((s) => Math.min(3, s + 0.1))}>
              <PlusOutlined />
            </button>
          </div>
        </div>
      } bordered>
            

            <div style={{ maxHeight: '600px', overflow: 'auto', display: 'flex', justifyContent: 'center' }}>
                <Document
                    file={pdfUrl}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    onLoadError={(err) => console.error("Error loading PDF:", err)}
                >
                    <Page pageNumber={pageNumber} scale={scale} />
                </Document>
            </div>
        </Card>
    );
});

export default PdfViewer;

// import { Card } from 'antd';
// import {  PageLayout, ScrollMode, Viewer, Worker } from '@react-pdf-viewer/core';
// import { RenderCurrentScaleProps, RenderZoomInProps, RenderZoomOutProps, zoomPlugin } from '@react-pdf-viewer/zoom';
// import { ZoomInIcon, ZoomOutIcon } from '@react-pdf-viewer/zoom';
//  import { PlusOutlined,MinusOutlined, DoubleRightOutlined, RightOutlined, LeftOutlined, DoubleLeftOutlined} from "@ant-design/icons";
// import '@react-pdf-viewer/zoom/lib/styles/index.css';

// import '@react-pdf-viewer/core/lib/styles/index.css';
// import workerUrl from 'pdfjs-dist/build/pdf.worker?url';
// import React, { useMemo } from 'react';
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// import { PlusOneOutlined, ZoomOutOutlined } from '@mui/icons-material';
// import { pageNavigationPlugin, RenderGoToPageProps } from '@react-pdf-viewer/page-navigation';
// import '@react-pdf-viewer/page-navigation/lib/styles/index.css';
// import { DownArrowIcon, NextIcon, PreviousIcon, UpArrowIcon } from '@react-pdf-viewer/page-navigation';
// import { scrollModePlugin  } from '@react-pdf-viewer/scroll-mode';
// //import '@react-pdf-viewer/scroll-mode/lib/styles/index.css';

// const PdfViewer = React.memo(({ base64 }: { base64: string }) => {

//    const zoomPluginInstance = zoomPlugin();
//    const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;

//    const pageNavigationPluginInstance = pageNavigationPlugin();
 

//     const scrollModePluginInstance = scrollModePlugin();
//      const { SwitchScrollMode } = scrollModePluginInstance;

//     //  const viewerRef = React.useRef(null);
//     // const pageNavigationPluginInstance = pageNavigationPlugin({
//     //     jumpToPage: (pageIndex) => {
//     //         viewerRef.current?.jumpToPage(pageIndex);
//     //     },
//     // });
//       const { CurrentPageInput, GoToFirstPageButton,jumpToPage, GoToLastPageButton, GoToNextPageButton,GoToNextPage,NumberOfPages, GoToPreviousPage } =
//     pageNavigationPluginInstance;
  

//     const base64ToBlob = (base64: string, type: string) => {
//         const binaryString = atob(base64);
//         const len = binaryString.length;
//         const bytes = new Uint8Array(len);
//         for (let i = 0; i < len; i++) {
//             bytes[i] = binaryString.charCodeAt(i);
//         }
//         return new Blob([bytes], { type });
//     };

//     // const pageLayout: PageLayout = {
//     //     transformSize: ({ size }) => ({
//     //         height: size.height + 30,
//     //         width: size.width + 30,
//     //     }),
//     // };

//     const pdfBlob = base64ToBlob(base64, 'application/pdf');
//     const pdfUrl = URL.createObjectURL(pdfBlob);

//      if (!base64) {
//         return <Card>Document not found.</Card>;
//     }
  

//     return (
//         <Card
//             title="PDF Viewer"
//             bordered={true}
//           //  style={}
//         >
//             <Worker workerUrl={workerUrl}>
//                 <div
//                  style={{
//                     alignItems: 'center',
//                   //  backgroundColor: '#eeeeee',
//                     // borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     padding: '3px',
//                     position:'absolute',
//                     top:10,
//                     right:20,
//                     gap: 5

                    
//                  }}>
//                     {/* <div style={{ padding: '0 2px' }}>
//                         <GoToFirstPage>
//                             {(props: RenderGoToPageProps) => (
//                                 <button
//                                     style={{
//                                         backgroundColor: '#357edd',
//                                         border: 'none',
//                                         borderRadius: '4px',
//                                         color: '#ffffff',
//                                         cursor: 'pointer',
//                                         padding: '8px',
//                                     }}
//                                     onClick={(e:any)=>{
//                                         e.preventDefault();
//                                         props.onClick()
                                        
//                                     }}
//                                 >
//                                     <DoubleLeftOutlined />
//                                 </button>
//                             )}
//                         </GoToFirstPage>
//                     </div> */}
//                     {/* <div style={{ padding: '0 2px' }}>
//                         <GoToPreviousPage>
//                             {(props: RenderGoToPageProps) => (
//                                 <button
//                                     style={{
//                                         backgroundColor: props.isDisabled ? '#96ccff' : '#357edd',
//                                         border: 'none',
//                                         borderRadius: '4px',
//                                         color: '#ffffff',
//                                         cursor: props.isDisabled ? 'not-allowed' : 'pointer',
//                                         padding: '8px',
//                                     }}
//                                     disabled={props.isDisabled}
//                                     onClick={(e:any)=>{
//                                         e.preventDefault();
//                                         props.onClick()
                                        
//                                     }}
//                                 >
//                                     <LeftOutlined />
//                                 </button>
//                             )}
//                         </GoToPreviousPage>
//                     </div>
//                     <div style={{ padding: '0px 2px', width: '4rem' }}>
//                         <CurrentPageInput />
//                     </div>
//                     <div style={{ padding: '0px 2px' }}>
//                         / <NumberOfPages />
//                     </div>
//                     <div style={{ padding: '0 2px' }}>
//                         <GoToNextPage>
//                             {(props: RenderGoToPageProps) => (
//                                 <button
//                                     style={{
//                                         backgroundColor: props.isDisabled ? '#96ccff' : '#357edd',
//                                         border: 'none',
//                                         borderRadius: '4px',
//                                         color: '#ffffff',
//                                         cursor: props.isDisabled ? 'not-allowed' : 'pointer',
//                                         padding: '8px',
//                                     }}
//                                     disabled={props.isDisabled}
//                                     onClick={(e:any)=>{
//                                         e.preventDefault();
//                                         props.onClick()
                                        
//                                     }}
//                                 >
//                                     <RightOutlined />
//                                 </button>
//                             )}
//                         </GoToNextPage>
//                     </div>  */}
//                     {/* <div style={{ padding: '0 2px' }}>
//                         <GoToLastPage>
//                             {(props: RenderGoToPageProps) => (
//                                 <button
//                                     style={{
//                                         backgroundColor: '#357edd',
//                                         border: 'none',
//                                         borderRadius: '4px',
//                                         color: '#ffffff',
//                                         cursor: 'pointer',
//                                         padding: '8px',
//                                     }}
//                                     onClick={(e:any)=>{
//                                         e.preventDefault();
//                                         props.onClick()
                                        
//                                     }}
//                                 >
//                                     <DoubleRightOutlined />
//                                 </button>
//                             )}
//                         </GoToLastPage>
//                     </div> */}


//                     {/* <div style={{ padding: '0px 2px' }}>
//                         <GoToFirstPageButton />
//                     </div>
//                     <div style={{ padding: '0px 2px' }}>
//                         <GoToPreviousPage />
//                     </div>
//                     <div style={{ padding: '0px 2px' }}>
//                         <CurrentPageInput />
//                     </div>
//                     <div style={{ padding: '0px 2px' }}>
//                         <GoToNextPageButton />
//                     </div>
//                     <div style={{ padding: '0px 2px' }}>
//                         <GoToLastPageButton />
//                     </div> */}
                

//                     {/*Zoom in Out*/}
//                     <div style={{ padding: '0px 2px' }}>
//                        <ZoomOut>
//                             {(props: RenderZoomOutProps) => (
//                                 <button className='btn-submit'
//                                     // style={{
//                                     //     backgroundColor: '#357edd',
//                                     //     border: 'none',
//                                     //     borderRadius: '4px',
//                                     //     color: '#ffffff',
//                                     //     cursor: 'pointer',
//                                     //     padding: '8px',
//                                     // }}
//                                     onClick={(e:any)=>{
//                                         e.preventDefault();
//                                         props.onClick()
                                        
//                                     }}
//                                 >
//                                     <MinusOutlined />
//                                 </button>
//                             )}
//                         </ZoomOut>
//                     </div>

//                     <div style={{ padding: '0px 2px' }}>
//                         <CurrentScale>
//                             {(props: RenderCurrentScaleProps) => <>{`${Math.round(props.scale * 100)}%`}</>}
//                         </CurrentScale>
//                     </div>

//                     <div style={{ padding: '0px 2px' }}>
//                         <ZoomIn>
//                             {(props: RenderZoomInProps) => (
//                                 <button className='btn-submit'
//                                     // style={{
//                                     //     backgroundColor: '#357edd',
//                                     //     border: 'none',
//                                     //     borderRadius: '4px',
//                                     //     color: '#ffffff',
//                                     //     cursor: 'pointer',
//                                     //     padding: '8px',
//                                     // }}
//                                     onClick={(e:any)=>{
//                                         e.preventDefault();
//                                         props.onClick()
                                        
//                                     }}
//                                 >
//                                     <PlusOutlined />
//                                 </button>
//                             )}
//                         </ZoomIn>
//                     </div>
//                 </div>

//                 <div style={{ margin: '1px 0',
//                     flex:1, padding: '5px', maxHeight: '600px', 
//                     overflow: 'auto'}}>
//                   <Viewer 
//                         fileUrl={pdfUrl} 
//                       //  ref={viewerRef}
//                         plugins={[zoomPluginInstance]}
                        
//                    />
//                 </div>
//             </Worker>
//         </Card>
//     );
// });

// export default PdfViewer;

